<template>
  <div class="fill-height">
    <router-view v-if="$route.name.includes('Show')"/>
    <TemplatePageGrid
      v-else-if="employeeSalaryPeriodGrid[0]"
      :items="employeeSalaryPeriodGrid"
      :page-data="pageData"
      :loading="loadingAnimation"
    >
      <template slot="buttons">
        <BaseInput
          type="select"
          v-model="selectedType"
          :items="typeOptions"
          item-text="text"
          item-value="value"
          :label="typeFilterLabel"
          placeholder="—"
          minimize
          class="max-width"
        />
      </template>
      <FinanceSalarySliceTable>
        <FinanceSalarySliceTableItem
          v-for="(item, i) in employeeSalaryPeriodGrid"
          :key="i"
          :item="item"
        />
      </FinanceSalarySliceTable>
    </TemplatePageGrid>
    <Plug v-else />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import TemplatePageGrid from "../../../components/templates/TemplatePageGrid";
import FinanceSalarySliceTable from "../../../components/finance/salary/FinanceSalarySliceTable";
import FinanceSalarySliceTableItem from "../../../components/finance/salary/FinanceSalarySliceTableItem";
import Plug from "../../../components/Plug";

export default {
  name: "salarySlice",
  components: {Plug, FinanceSalarySliceTableItem, FinanceSalarySliceTable, TemplatePageGrid},
  computed: {
    ...mapGetters(['loadingAnimation']),
    ...mapGetters('employeeSalaryPeriod', ['employeeSalaryPeriodGrid', 'pageData']),
    typeOptions() {
      const t = this.localStorage?.translations?.pages?.finance?.['salary-table'] || {}
      return [
        { text: t['all_worker_groups'] || 'All Worker Groups', value: 'all' },
        { text: t['workers'] || 'Workers', value: 'workers' },
        { text: t['officials'] || 'Officials', value: 'officials' },
      ]
    },
    typeFilterLabel() {
      const t = this.localStorage?.translations?.pages?.finance?.['salary-table'] || {}
      return t['worker_group'] || 'Worker group'
    },
  },
  data: () => ({
    selectedType: 'all',
  }),
  created() {
    this.selectedType = this.$route.query.type || 'all'
    this.onDownloadPageData()
  },
  watch: {
    '$route.query'() {
      this.selectedType = this.$route.query.type || 'all'
      this.onDownloadPageData()
    },
    selectedType() {
      this.updateRouteQuery()
    },
  },
  methods: {
    ...mapActions('employeeSalaryPeriod', ['onEmployeeSalaryPeriodGrid']),
    ...mapMutations(['setLoadingAnimation']),
    async onDownloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      if (this.selectedType !== 'all') {
        data.type = this.selectedType
      }
      if (!this.$route.name.includes('Show'))
      await this.onEmployeeSalaryPeriodGrid(data)
      this.setLoadingAnimation(false)
    },
    updateRouteQuery() {
      const nextType = this.selectedType === 'all' ? undefined : this.selectedType
      const currentType = this.$route.query.type
      if (currentType === nextType || (!currentType && !nextType)) return
      const nextQuery = {
        ...this.$route.query,
        type: nextType,
        page: 1,
      }
      if (!nextType) delete nextQuery.type
      this.$router.replace({ query: nextQuery })
    },
  }
}
</script>
